import axios from '../base/axios';
import API_KEY from './key';

const GET_TVSCIFIANDFANTASY = 'flixfrenzy/redux/GET_TVSCIFIANDFANTASY';

// eslint-disable-next-line default-param-last
const tvSciFiAndFantasyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVSCIFIANDFANTASY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvSciFiAndFantasy = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10765`).then((res) => {
    dispatch({
      type: GET_TVSCIFIANDFANTASY,
      payload: res.data,
    });
  });
};

export default tvSciFiAndFantasyReducer;
